import Select from '@/components/Select';

const PageSelect = ({ label, value, disabled, options = [], onChange, placeholder, ...props }) => {
  return (
    <div className={'comp-page-input-row'}>
      {!!label && <div className={'label'}>{label}</div>}
      <Select className={'select'} options={options} value={value} disabled={disabled} onChange={onChange} placeholder={placeholder} {...props} />
    </div>
  );
};

export default PageSelect;
